import { Flex, type FlexProps, Text } from '@chakra-ui/react'
import React from 'react'
import {
  NotificationBadgeSize,
  NotificationBadgeVariant,
  useNotificationBadgeStyle,
} from '~/components/shared/componentStyles/NotificationBadge.style'
import { Size } from '~/types/ThemeTypes'

interface NotificationBadgeProps extends FlexProps {
  count: string | number | undefined
  variant?: NotificationBadgeVariant
  size?: NotificationBadgeSize
}

export const NotificationBadge = ({
  count,
  variant = NotificationBadgeVariant.Notification,
  size = Size.md,
  ...rest
}: NotificationBadgeProps) => {
  const styles = useNotificationBadgeStyle({
    variant,
    size,
  })

  // Extract layout properties to apply as native props (Chakra v3 requirement)
  const containerProps = {
    display: styles.container?.display,
    flexDirection: styles.container?.flexDirection,
    justifyContent: styles.container?.justifyContent,
    alignItems: styles.container?.alignItems,
  }

  const contentContainerProps = {
    display: styles.contentContainer?.display,
    flexDirection: styles.contentContainer?.flexDirection,
    justifyContent: styles.contentContainer?.justifyContent,
    alignItems: styles.contentContainer?.alignItems,
  }

  return (
    <Flex css={styles.container} {...containerProps} {...rest}>
      <Flex css={styles.contentContainer} {...contentContainerProps}>
        <Text css={styles.text}>{count}</Text>
      </Flex>
    </Flex>
  )
}
